<template>
  <div class="photoCommander" style="border: 10px solid #edeff2">
    <div class="topUp">
      <div>
        <div class="displayInline">
        <span>观看流量：</span>
        <div class="progress">
          <a-progress
          :percent="statisticsData.flux.usedFlux/statisticsData.flux.totalFlux*100" :show-info="false" />
          <div style="margin-left: 10px;width: 50px;">G</div>
        </div>
        <div>
          总量：{{ statisticsData.flux.totalFlux}}G
        </div>
        <div>
          使用：{{ statisticsData.flux.usedFlux}}G
        </div>
        <div>
          剩余：{{ statisticsData.flux.remainFlux}}G
        </div>
        <div>
          <a-button size="small" @click="openPro('liuliang')">
            充值
          </a-button>
        </div>
        </div>
        <div class="displayInline">
        <span>录制时长：</span>
        <div class="progress">
          <a-progress
          :percent="statisticsData.duration.usedOriginDuration/statisticsData.duration.totalOriginDuration*100" :show-info="false" />
          <div style="margin-left: 10px;width: 50px;">小时</div>
        </div>
        <div>
          总量：{{ statisticsData.duration.totalDuration}}
        </div>
        <div>
          使用：{{ statisticsData.duration.usedDuration}}
        </div>
        <div>
          剩余：{{ statisticsData.duration.remainDuration}}
        </div>
        <div>
          <a-button size="small" @click="openPro('luzhi')">
            充值
          </a-button>
        </div>
        </div>
        <div class="displayInline">
        <span>存储空间：</span>
        <div class="progress">
          <a-progress :percent="statisticsData.fileSize.usedFileSize/statisticsData.fileSize.totalFileSize*100" :show-info="false" />
          <div style="margin-left: 10px;width: 50px;">G</div>
        </div>
        <div>
          总量：{{ statisticsData.fileSize.totalFileSize}}G
        </div>
        <div>
          使用：{{ statisticsData.fileSize.usedFileSize}}G
        </div>
        <div>
          剩余：{{ statisticsData.fileSize.remainFileSize}}G
        </div>
        <div>
          <a-button size="small" @click="openPro('kongjian')">
            充值
          </a-button>
        </div>

        </div>
        <div class="displayInline" style="margin-bottom: 0;">
          <span>点播流量：</span>
          <div class="progress">
            <a-progress :percent="statisticsData?.videoFlux?.usedVideoFlux/statisticsData?.videoFlux?.totalVideoFlux*100" :show-info="false" />
            <div style="margin-left: 10px;width: 50px;">G</div>
          </div>
          <div>
            总量：{{ statisticsData?.videoFlux?.totalVideoFlux}}G
          </div>
          <div>
            使用：{{ statisticsData?.videoFlux?.usedVideoFlux}}G
          </div>
          <div>
            剩余：{{ statisticsData?.videoFlux?.remainVideoFlux}}G
          </div>
          <div>
            <a-button size="small" @click="openPro('kongjian')">
              充值
            </a-button>
          </div>
        </div>
      </div>
      <div>
        <a-alert style="" type="info" show-icon size="small" v-if="!this.userInfoList.id && !this.isKefu">
          <span slot="message" style="font-weight: normal">完成认证客户 平台将赠送:
          <div style="font-weight: bold;margin-top: 6px;">观看流量100G、录制时长1小时、存储空间1G</div>
          <a style="margin-top: 6px;display:inline-block" @click="toAuthentication">前往认证</a></span>
        </a-alert>
      </div>
    </div>
    <div>
      <!-- 按钮 -->
      <div class="disTable">
        <div style="width: 100%;display: flex;justify-content: space-between;margin-bottom: 20px;">
          <a-button type="primary" @click="newlyBuild">
            新建
          </a-button>
          <div>
            <a-radio-group default-value="" button-style="solid" v-model="isExpire" @change="radioChange">
              <a-radio-button value="">
                全部
              </a-radio-button>
              <a-radio-button value="0">
                未过期
              </a-radio-button>
              <a-radio-button value="1">
                已过期
              </a-radio-button>
            </a-radio-group>
        </div>
        </div>
      <a-table :scroll="{ x: 1200 }" :columns="columns" :data-source="dataTable" :pagination="false"
      >
        <template slot="tableStatus" slot-scope="text, record">
          <a-tag v-if="record.isExpire === 1">已过期</a-tag>
          <a-tag v-if="record.isExpire === 0" color="green">有效</a-tag>
          <div style="margin-top:12px">{{ record.expireTime.substring(0,record.expireTime.length-3) }}</div>
        </template>
        <!-- 观看地址 -->
        <template slot="watchAddress" slot-scope="text, record">
          <a @click="Settings(record)" v-if="record.conventionLink && record.conventionLinkIsOpen === 0">设置</a>
          <div v-else>
            <!-- replayIsOpen -->
            <a-tag v-if="record.replayIsOpen === 1" color="blue">回放已开启</a-tag>
            <a-tag v-if="record.replayIsOpen === 0">回放未开启</a-tag>
            <div style="display: flex;align-items: center;margin-bottom: 10px;margin-top: 10px;">
              <div style="margin-right:10px">
                {{ record.conventionLink }}
              </div>
              <div style="color: #1374ce;display: flex;">
                <a-icon type="edit" style="margin-right:10px" @click="editData(record)"/>
                <a-icon @click="copySum(record.conventionLink)" type="copy" />
              </div>
            </div>
          </div>
        </template>
        <template slot="pushIpAll" slot-scope="text, record">
          <a-tag v-if="record.isRecord == 0">录制未开启</a-tag>
          <a-tag v-else color="orange" @click="openModal(record)">录制视频数量：{{ record.fileNums }}</a-tag>
          <div style="display: flex;align-items: center;margin-bottom: 10px;margin-top: 10px;">
            <div style="margin-right:10px">
               <span style="font-weight:bold">服务器：</span>{{ record.pushIp }}
            </div>
            <div style="color: #1374ce;">
              <a-icon @click="copySum(record.pushIp)" type="copy" />
            </div>

          </div>
          <div style="display: flex;align-items: center;">
            <div style="margin-right:10px">
               <span style="font-weight:bold">串流密钥：</span>{{ record.pushKey }}
            </div>
            <div style="color: #1374ce;">
              <a-icon @click="copySum(record.pushKey)" type="copy" />
            </div>
          </div>
        </template>
        <template slot="address" slot-scope="text, record">
          <div class="StreamAddress">
            <div class="fontAddress">
              <span style="font-weight:bold">rtmp：</span>{{ record.pullRtmpIp }}
            </div>
            <div class="fontCopy">
              <a-icon @click="copySum(record.pullRtmpIp)" type="copy" />
            </div>
          </div>
          <div class="StreamAddress">
            <div class="fontAddress">
              <span style="font-weight:bold">flv：</span>{{ record.pullFlvIp }}
            </div>
            <div class="fontCopy">
              <a-icon @click="copySum(record.pullFlvIp)" type="copy" />
            </div>
          </div>
          <div class="StreamAddress">
            <div class="fontAddress">
              <span style="font-weight:bold">m3u8：</span>{{ record.pullM3u8Ip }}
            </div>
            <div class="fontCopy">
              <a-icon @click="copySum(record.pullM3u8Ip)" type="copy" />
            </div>
          </div>
        </template>
        <template slot="remarkValue" slot-scope="text, record">
          <!-- @click="editRemark(record)" -->
          <a v-if="record.remark" @click="editRemark(record)" >{{ record.remark }}</a>
          <a v-else @click="editRemark(record)" style="display: block;width:20px" >-</a>
        </template>

        <!-- <template slot="theRecord" slot-scope="text, record">
          <span v-if="record.isRecord == 0">未开启</span>
          <a v-else @click="openModal(record)"> {{ record.fileNums }}</a>
        </template> -->
      </a-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <a-pagination
            :current="paginationDrawer.curPage"
            :total="paginationDrawer.total"
            :pageSize="paginationDrawer.pageSize"
            show-quick-jumper
            @change="PageDrawerchange"
        />
      </div>
      </div>

      <a-modal
        title="新建"
        :visible="addVisible"
        @ok="addSubmit"
        @cancel="addClose"
        width="600px"
      >
        <a-form-model
          :model="addForm"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :rules="formRules"
          ref="addForm"
          :pagination="false"
        >
          <a-form-model-item label="到期时间" prop="expireTime">
            <a-date-picker
              format="YYYY-MM-DD HH:mm"
              valueFormat="YYYY-MM-DD HH:mm"
               v-model="addForm.expireTime"
              style="width: 70%;"
              :disabled-date="disabledDate"
              :show-time="{ defaultValue: moment('00:00', 'HH:mm'),showSecond: false}
              "
            />
             <!-- -->
          </a-form-model-item>
          <a-form-model-item label="录制是否开启" prop="isRecord">
            <a-switch
              :checked="addForm.isRecord !== 0"
              @click="openEdit(addForm.isRecord === 1 ? 0 : 1)"
              checked-children="是"
              un-checked-children="否"
            />
            <br>
            <div style="font-size:12px;color:#ccc;margin-top: -10px;color:red">* 注意：录制选择不开启后 将无法生成回看</div>
          </a-form-model-item>
          <!-- 备注 -->
          <a-form-model-item label="备注" prop="intro">
            <a-textarea
              v-model="addForm.remark"
              placeholder="请输入"
              style="height: 100px"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>


      <a-modal
        title="设置"
        :visible="setVisible"
        @ok="setSubmit"
        @cancel="setClose"
        width="600px">
          <a-form-model
            :model="setForm"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :rules="setRules"
            ref="setForm"
            :pagination="false"
          >
            <a-form-model-item label="观看地址" prop="isRecord">
              <a-switch
                :checked="setForm.conventionLinkIsOpen !== 0"
                @click="setOpen(setForm.conventionLinkIsOpen === 1 ? 0 : 1)"
                checked-children="是"
                un-checked-children="否"
              />
              <!-- <br>
              <div style="font-size:12px;color:#ccc;margin-top: -10px;color:red">* 注意：录制选择不开启后 将无法生成回看</div> -->
            </a-form-model-item>
            <a-form-model-item label="会议时间" prop="conventionStartTime">
              <a-date-picker
                format="YYYY-MM-DD HH:mm"
                valueFormat="YYYY-MM-DD HH:mm"
                 v-model="setForm.conventionStartTime"
                 style="width: 70%;"
                :disabled-date="disabledDate"
                :show-time="{ defaultValue: moment('00:00', 'HH:mm'),showSecond: false}
                "
              />
            </a-form-model-item>
            <a-form-model-item label="会议名称" prop="conventionTitle">
              <a-input v-model="setForm.conventionTitle" style="width: 70%;" placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item label="会议KV图" prop="headImg">
              <div>
                <div style="display: flex">
                  <div class="uploadImg">
                    <input
                        id="inputTest"
                        ref="addImg"
                        accept="image/*"
                        style="width: 100%;height:100%;opacity: 0;z-index: 99"
                        type="file"
                        @change="uploadImg('addImg')"/>
                    <span v-show="setForm.kvUrl == ''" style="z-index: -1;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);font-size: 20px;">+</span>
                  </div>

                  <div class="upload_gutter">
                    <img
                        v-if="setForm.kvUrl"
                        :src="setForm.kvUrl"
                        alt=""
                        style="width: 200px;height: 120px;position: absolute;left: 0;z-index: 0;"
                    />
                  </div>
                </div>
                <span style="font-size: xx-small">注：尺寸100*100，大小不超过500kb</span>
              </div>
            </a-form-model-item>

            <a-form-model-item label="会议详情">
              <div style="border: 1px solid #ccc; width: 100%">
                <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
                />
                <Editor
                  style="height: 270px; overflow-y: hidden"
                  v-model="setForm.conventionDetail"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
                />
              </div>
            </a-form-model-item>


            <a-form-model-item label="开启回放" prop="isRecord">
              <a-switch
                :checked="setForm.replayIsOpen !== 0"
                @click="replayOpen(setForm,setForm.replayIsOpen === 1 ? 0 : 1)"
                checked-children="是"
                un-checked-children="否"
              />
              <br>
              <div style="font-size:12px;color:#ccc;margin-top: -10px;color:red">注意：开启回放后将会产生点播流量</div>
            </a-form-model-item>
          </a-form-model>
      </a-modal>

      <a-modal
        title="备注"
        :visible="remarkVisible"
        @ok="remarkSubmit"
        @cancel="remarkClose"
        width="600px"
      >
        <a-form-model
          :model="remarkForm"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          ref="remarkForm"
          :pagination="false"
        >
          <!-- 备注 -->
          <a-form-model-item label="备注">
            <a-textarea
              v-model="remarkForm.remark"
              placeholder="请输入"
              style="height: 100px"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>


      <!-- @ok="()=>{liveVisible = false}" -->
      <a-modal
        title="录制"
        :visible="liveVisible"
        @cancel="()=>{liveVisible = false}"
        :footer="null"
        width="600px"
        :pagination="null"
      >
        <a-table
          :columns="LiveColumns"
          :data-source="LiveTable"
          :pagination="false"
          row-key="id"
        >
          <span slot="videoUrlWithSign" slot-scope="text,record" >
            <!-- <a-tooltip placement="topLeft">
              <template slot="title">
                {{ text }}
              </template>
              <div class="multi-ellipsis"> <span>{{ record.videoUrlWithSign }}</span></div>
            </a-tooltip> -->
            <span>{{ record.fileName }}</span>
          </span>
          <span slot="videoDuration" slot-scope="text,record" >
            {{ record.duration }}
          </span>
          <template slot="download" slot-scope="text, record">
            <a type="primary" size="small" @click="download(record.videoUrlWithSign)">下载</a>
          </template>
        </a-table>
      </a-modal>
      <!-- 产品订购 -->
      <ProductOrderingNew
        v-if="visibleProductOrdering"
        :visible="visibleProductOrdering"
        :bagButton="false"
        :code="code"
        v-on:closeProductOrdering="closeProductOrdering"
      />
      <!-- :conventionCode="meetCode" -->
      <!--  认证提示-->
      <MessageAlert
        :visible="visibleAlert"
        v-on:closeMain="closeMainAlert"
        :isFrom="Live"
      ></MessageAlert>


      <!--认证-->
      <RealNameAuthentication
          :visible="visibleAuthentication"
          :isShow="isShow"
          :jurisdiction="jurisdiction"
          v-on:closeMainRealNameAuth="closeMain"
          :isFrom="isFrom"
      ></RealNameAuthentication>
    </div>
  </div>
</template>

<script>
import {update} from "@/utils/update";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import headerConfig from "../../../service/api_header_config";
const headerApi = headerConfig.api_header;
import TcVod from "vod-js-sdk-v6";
import { getSignature } from "@/service/columnmanageapi";
const signature = "";
import {
  getAuthenticationInformation
} from "@/service/authentication";
import MessageAlert from "@/components/Authentication/MessageAlert";
import RealNameAuthentication from "@/components/Authentication/RealNameAuthentication";
import {
 getStatistics,getList,postLiveUrl,putLiveUrl,getRecord,putWatchDetail
} from "../../../service/LiveToStreaming";
import ProductOrderingNew from "@/components/PaidView/ProductOrderingNew";
// import payIndent from "@/components/PaidView/payIndent";
import axios from "axios";

import moment from 'moment';
const editorConfig = {
  // JS 语法
  MENU_CONF: {},
};
const columns = [
  // {
  //   title: '到期时间',
  //   dataIndex: 'expireTime',
  //   key: 'expireTime',
  //   width: 180,
  // },
  {
    title: '到期时间',
    key: 'isExpire',
    width: 180,
    scopedSlots: { customRender: 'tableStatus' },
  },
  {
    title: '观看地址',
    key: 'watchAddress',
    width: 220,
    scopedSlots: { customRender: 'watchAddress' },
  },
  {
    title: '推流',
    dataIndex: 'pushIpAll',
    key: 'pushIpAll',
    width: 370,
    scopedSlots: { customRender: 'pushIpAll' },
  },{
    title: '拉流地址',
    width: 470,
    scopedSlots: { customRender: 'address' },
  },
  // {
  //   title: '录制',
  //   dataIndex: 'isRecord',
  //   key: 'isRecord',
  //   width: 80,
  //   align: 'center',
  //   scopedSlots: { customRender: 'theRecord' },
  // },
  // {
  //   title: '观看地址',
  //   width: 100,
  //   align: 'center',
  //   scopedSlots: { customRender: 'watchAddress' },
  // },
  // {
  //   title: '到期时间',
  //   dataIndex: 'expireTime',
  //   key: 'expireTime',
  //   width: 180,
  // },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    width: 200,
    scopedSlots: { customRender: 'remarkValue' },
  }
];
// 修改 uploadImage 菜单配置
editorConfig.MENU_CONF["uploadImage"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    const user_info = window.localStorage.getItem("yichi_userInfo");
    let formData = new FormData();
    formData.append("file", file);
    // file 即选中的文件,自己实现上传，并得到图片 url alt href
    axios
      .post(headerApi + "/api/admin/common/update", formData, {
        headers: {
          "x-token": JSON.parse(user_info).id,
          token: JSON.parse(user_info).token,
        },
      })
      .then((res) => {
        if (res.data.code === 0) {
          insertFn(res.data.data.url); // 最后插入图片
        }
      });
  },
};
// 修改 uploadVideo 菜单配置
editorConfig.MENU_CONF["uploadVideo"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    const user_info = window.localStorage.getItem("yichi_userInfo");
    let mediaFile = file;
    // console.log(file)
    // axios.post(headerApi+'/api/admin/uploadVideo', mediaFile,{
    //   headers: {
    //     'token':JSON.parse(user_info).token
    //   }
    // }).then((res) => {
    //   if(res.data.code === 0){
    //     insertFn(res.data.data.url)// 最后插入图片
    //   }
    // })

    //获取签名
    getSignature().then((res) => {
      if (res.code === 0) {
        // console.log(res)
        const getSignature = () => {
          return res.data.signature;
        };
        const tcVod = new TcVod({
          getSignature: getSignature, //上传签名的函数
          // appId:1500024305 //appid
        });
        const uploader = tcVod.upload({
          mediaFile: mediaFile, // 媒体文件（视频或音频或图片），类型为 File
        });
        uploader.done().then((res) => {
          insertFn(res.video.url); // 进行视频处理：转码和截图
        });
      }
    });
  },
};
export default {
  created() {
    this.getInformation();
    this.getTJData();  // 统计
    this.getListData();  // 直播流列表
  },
  components: { ProductOrderingNew ,MessageAlert,RealNameAuthentication,Editor,Toolbar,},
  data() {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig,
      mode: "default", // or 'simple'
      isFrom: "",
      visibleAuthentication:false,
      visibleUnderReview:false,
      isShow:{},
      jurisdiction:false,
      setVisible: false,
      setForm:{
        kvUrl:'',
        conventionLinkIsOpen:0,
        replayIsOpen:0
      },
      visibleAlert: false,
      userInfoList: {},
      payVisible: false,
      visibleProductOrdering: false,
      LiveTable: [],
      LiveColumns: [
        {
          title: '视频名称',
          dataIndex: 'videoUrlWithSign',
          key: 'videoUrlWithSign',
          // width: '70%',
          scopedSlots: { customRender: 'videoUrlWithSign' },
        },
        {
          title: '时长（分钟）',
          dataIndex: 'videoDuration',
          key: 'videoDuration',
          // width: '70%',
          scopedSlots: { customRender: 'videoDuration' },
        },
        {
          title: '操作',
          align: 'center',
          scopedSlots: { customRender: 'download' },
        },
      ],
      liveVisible: false,
      remarkForm:{
      },
      Live: "Live",
      remarkVisible: false,
      paginationDrawer:{
        curPage:1,
        pageSize:10,
        total:0,
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 17 }, //14
      addForm:{isRecord:0},
      columns,
      dataTable: [],
      addVisible: false,
      formRules: {
        expireTime: [{ required: true, message: "请选择", trigger: "change" }],
      },
      setRules:{
        conventionStartTime: [{ required: true, message: "请选择", trigger: "change" }],
        conventionTitle: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      statisticsData:{
        flux:{
          remainFlux: 0,
          totalFlux: 0,
          usedFlux: 0
        },
        fileSize:{
          remainFileSize: 0,
          totalFileSize: 0,
          usedFileSize: 0
        },
        duration:{
          remainDuration: 0,
          totalDuration: 0,
          usedDuration: 0,
          totalDuration: "0小时0分",
          usedDuration: "0小时0分",
          remainDuration: "0小时0分",
        }
      },
      isExpire: "",
      code: "liuliang",
      isKefu: null,
      setId:0,
    };
  },
  watch:{
    visibleProductOrdering(val){
      if(!val){
        setTimeout(() => {
          this.getTJData();  // 统计
        }, 500);
      }
    },
    visibleAuthentication(val){
      if(!val){
        setTimeout(() => {
          // console.log("?????刷新了吗")
          this.getInformation();
          // this.getTJData();  // 统计
        }, 500);
      }
    },
  },
  methods:{
    //上传图片
    async uploadImg(type) {
      var inputTest = document.querySelector('#inputTest')
      let inputDOM = this.$refs[type].files[0];
      const image = await update(inputDOM)
      if (image.code === 0){
        this.setForm.kvUrl = image.data.url
      }
      inputTest.value =''
      // if(inputDOM.size < 512000 ){
      // }
      // else{
      //   this.$message.warning('仅上传500k内图片')
      // }
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    toAuthentication(){
      this.visibleAuthentication = true;
    },
    closeMainAlert(val) {
      this.visibleAlert = val;
    },
    closeMain(val){
      this.visibleAuthentication = val;
    },
    async getInformation() {
      const response = await getAuthenticationInformation();
      if (response.code === 200) {
        this.userInfoList = response.data;
        this.getTJData();  // 统计
        // console.log("父组件刷新")
      } else {
        this.$message.warning("name", response.message);
      }
    },
    getFilename(path) {
      const lastSlashIndex = path.lastIndexOf('/');
      // 如果没有找到斜杠，返回整个字符串
      return lastSlashIndex === -1 ? path : path.substring(lastSlashIndex + 1);
    },
    moment,
    openPro(code){
      if (!this.userInfoList.id && !this.isKefu) {
        //未认证且不是客服
        this.visibleAlert = true;
        return
      }
      this.code = code;
      this.visibleProductOrdering = true
    },
    closeProductOrdering(val) {
      this.visibleProductOrdering = val;
      // this.code = "";
    },
    // 获取统计
    async getTJData(){
      let res = await getStatistics();
      if(res.code === 0){
        this.statisticsData = res.data;
        console.log("数据",this.statisticsData)
      }
    },

    // 获取直播流列表
    async getListData(){
      let res = await getList({
        pageNo: this.paginationDrawer.curPage,
        pageSize: this.paginationDrawer.pageSize,
        isExpire: this.isExpire
      });
      if(res.code === 0){
        this.dataTable = res.data;
        this.paginationDrawer.total = res.count;
        console.log("直播流列表",res.data);
      }
    },
    PageDrawerchange(pageNo,pageSize){
      this.paginationDrawer.curPage = pageNo;
      this.paginationDrawer.pageSize = pageSize;
      this.getListData();
    },

    radioChange(){
      this.paginationDrawer.curPage = 1;
      this.getListData();
    },
    newlyBuild() {
      if (!this.userInfoList.id && !this.isKefu) {
        //未认证且不是客服
        this.visibleAlert = true;
        return
      }
      if(this.statisticsData.flux.remainFlux == 0){
        this.$message.warning("您的观看流量不足，请充值后再使用");
        return;
      }
      this.addVisible = true;
    },
    async addSubmit() {
      // 新增提交
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          // console.log(this.addForm);
          if(!this.addForm.id){
            let data = {
              expireTime: this.addForm.expireTime+':00',
              isRecord: this.addForm.isRecord,
              remark: this.addForm.remark,
            }
            let res = await postLiveUrl(data);
            if(res.code === 0){
              this.$message.success("新增成功");
              this.addVisible = false;
              this.addForm = {isRecord: 0}  //isRecord: 0 ,patientIsOpen:0,memberIsAuth:0,memberisRecord:0
              this.$refs.addForm.resetFields();
              this.getListData();
            }else{
              this.$message.warning(res.message)
            }
          }
          // else{ // 修改
          //   if(this.addForm.expireTime.length == 16){
          //     this.addForm.expireTime = this.addForm.expireTime+':00'
          //   }
          //   let res = await putLiveUrl(this.addForm);
          //   if(res.code === 0){
          //     this.$message.success("修改成功");
          //     this.addVisible = false;
          //     this.addForm = {isRecord: 0}  //isRecord: 0 ,patientIsOpen:0,memberIsAuth:0,memberisRecord:0
          //     this.$refs.addForm.resetFields();
          //     this.getListData();
          //   }else{
          //     this.$message.warning(res.message)
          //   }
          // }
        }
      })
    },
    // 备注提交
    remarkSubmit() {
      // 新增提交
      this.$refs.remarkForm.validate(async (valid) => {
        if (valid) {
          let form = {
            id: this.remarkForm.id,
            remark: this.remarkForm.remark,
          }
          // console.log(data);
          let res = await putLiveUrl(form);
          if(res.code === 0){
            this.$message.success("修改成功");
            this.remarkVisible = false;
            this.remarkForm = {}  //isRecord: 0 ,patientIsOpen:0,memberIsAuth:0,memberisRecord:0
            this.$refs.remarkForm.resetFields();
            this.getListData();
          }
        }
      })
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf('day');
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledDateTime() {
      return {
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    },
    addClose() {
      this.addVisible = false;
      this.addForm = {isRecord: 0}  //isRecord: 0 ,patientIsOpen:0,memberIsAuth:0,memberisRecord:0
      this.$refs.addForm.resetFields();
    },
    remarkClose(){
      this.remarkVisible = false;
      this.remarkForm = {}
      this.$refs.remarkForm.resetFields();
    },
    setClose(){
      this.setVisible = false;
      this.setForm = {kvUrl:'',conventionLinkIsOpen:0,replayIsOpen:0}
      this.$refs.setForm.resetFields();
    },
    openEdit(open) {
      if(this.statisticsData.duration.remainOriginDuration == 0){
        this.$message.warning("您的录制时长不足，请充值后再使用");
        return;
      }
      if(this.statisticsData.fileSize.remainFileSize == 0){
        this.$message.warning("您的存储空间不足，请充值后再使用");
        return;
      }
      this.addForm.isRecord = open;
    },
    setOpen(open){
      this.setForm.conventionLinkIsOpen = open
      // this.setForm.replayIsOpen = 0; //切换时关闭回放开关
    },
    // 开启回放
    replayOpen(item,open){
      // console.log("数据",item)
      if(item.isRecord === 0){
        this.$message.warning("录制未开启，无法开启回放");
        return;
      }
      this.setForm.replayIsOpen = open;
    },
    copySum (item) {
      //创建input标签
      var input = document.createElement('input')
      //将input的值设置为需要复制的内容
      input.value = item;
      //添加input标签
      document.body.appendChild(input)
      //选中input标签
      input.select()
      //执行复制
      document.execCommand('copy')
      //成功提示信息
      this.$message.success('复制成功 ！')
      //移除input标签
      document.body.removeChild(input)
    },
    // 修改备注
    editRemark(record){
      this.remarkForm.remark = record.remark;
      this.remarkVisible = true;
      this.remarkForm.id = record.id;
    },
    // 开录制下载弹窗
    async openModal(record){
      let res = await getRecord(record.streamId);
      if(res.code === 0){
        this.LiveTable = res.data;
      }else{
        this.$message.error(res.message);
      }
      this.liveVisible = true;
    },
    download(url){
      window.open(url);
    },
    // 设置
    Settings(record){
      // this.setForm = record;
      this.setId = record.id;
      this.setForm = JSON.parse(JSON.stringify(record));
      this.setVisible = true;
    },
    // 设置提交
    setSubmit(){
      // 新增提交
      this.$refs.setForm.validate(async (valid) => {
        if (valid) {
          // this.setForm.id = this.setId;
          // this.setForm.conventionStartTime = this.setForm.conventionStartTime + ':00';
          // console.log("数据",this.setForm)
          let data = {
            "id": this.setId,
            "kvUrl": this.setForm.kvUrl,//kv图
            "conventionTitle": this.setForm.conventionTitle,//会议名称
            "conventionDetail": this.setForm.conventionDetail,//会议地址
            "conventionLinkIsOpen": this.setForm.conventionLinkIsOpen,//观看地址是否开启，1是，0否
            "replayIsOpen": this.setForm.replayIsOpen,//回放是否开启，1是，0否
            "conventionStartTime": this.setForm.conventionStartTime.length === 16 ? this.setForm.conventionStartTime + ':00': this.setForm.conventionStartTime //会议时间,具体到小时，秒数补0
          }
          let res = await putWatchDetail(data);
          if(res.code === 0){
            this.$message.success("设置成功");
            this.setVisible = false;
            this.setForm = {kvUrl:'',conventionLinkIsOpen:0,replayIsOpen:0}
            this.$refs.setForm.resetFields();
            this.getListData();
          }
        }
      })
    },
    editData(record){
      this.setId = record.id;
      this.setVisible = true;
      this.setForm = JSON.parse(JSON.stringify(record));
    }
  }
}
</script>

<style lang="scss" scoped>
  //.uploadImg {
  //border: #dddddd 2px dashed;
  //width: 120px;
  //height: 120px;
//
  ////  background-image: url("../../../assets/add.png");
  //background-size: 100% 100%;
  //background-repeat: no-repeat;
  //cursor: pointer;
//
  //.add {
  //  font-size: 50px;
  //  color: #bdbcbc;
  //}
  //}

  .upload{
  position: relative;
  border: 1px #DDDDDD dashed;
  width: 100px;
  height: 100px;
  input{
    z-index:2;width: 100%;height: 100%;opacity: 0;cursor: pointer;
  }
  .upload_text{
    cursor: pointer;position: absolute;top: 40%;left: 35%;text-align: center;z-index: -1
  }
}

.uploadImg {
  border: #DDDDDD 2px dashed;
  width: 200px;
  height: 120px;
  // background-image: url("../../../assets/add.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.photoCommander {
  width: 100%;
  height: auto;
  .topUp{
    border-bottom: 10px solid #edeff2;
    padding: 20px;
    // padding-right:12px;
    display: flex;
    justify-content: space-between;
    .displayInline{
      display: grid;
      grid-template-columns: 74px 350px 110px 130px 146px 60px;
      margin-bottom: 10px;
      .progress{
        display: flex;
        // align-items: center;
      }
    }
  }
  .disTable{
    padding: 20px;
  }
}
::v-deep .ant-btn-sm {
  color:#40a8ff;
  border-color:#40a8ff;
}

.StreamAddress{
  display: flex;align-items: center;
  margin-bottom: 10px;
  .fontAddress{
    width: 90%;
  }
  .fontCopy{
    color: #1374ce;
  }
}
  .multi-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; // 超出一行则以...形式隐藏
  -webkit-box-orient: vertical;
  cursor: pointer;
  // background-color: green;
}
::v-deep .ant-progress-status-success .ant-progress-bg {
  background-color: red;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
